import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import { TimeSlot } from '@lib/core/models/create-appointment.interface';

@Component({
  selector: 'shared-time-slots',
  standalone: true,
  imports: [NgClass],
  templateUrl: './time-slots.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimeSlotsComponent {
  slots = input.required<TimeSlot[]>();
  loading = input<boolean>(false);
  selectedSlot = input<TimeSlot | null>(null);

  slotSelected = output<TimeSlot>();

  protected readonly today: Date = new Date();

  protected readonly uiDays = computed(() => {
    const uiDays = [];

    for (let i = 0; i < 7; i++) {
      const date = new Date(this.today);
      date.setDate(this.today.getDate() + i);

      const slot = this.slots().find(s => {
        const slotDate = new Date(s.startTime);
        return slotDate.toDateString() === date.toDateString();
      });

      uiDays.push({
        date: date.toISOString(),
        slot: slot || null,
        available: !!slot,
      });
    }

    return uiDays;
  });

  protected selectUiDay(uiDay: any): void {
    if (uiDay.available && uiDay.slot) this.slotSelected.emit(uiDay.slot);
  }

  protected getUiDayClasses(uiDay: any): string {
    if (!uiDay.available) return 'bg-gray-3 text-gray-400 border-gray-2 border';
    else if (this.selectedSlot() === uiDay.slot) return 'bg-primary-500 text-white';
    else return 'border-gray-200 border bg-white';
  }

  protected formatSlotDate(dateString: string): string {
    const date = new Date(dateString);

    return date.toLocaleDateString('uk-UA', { day: '2-digit', month: '2-digit' });
  }

  protected formatSlotDay(dateString: string): string {
    const date = new Date(dateString);
    const days = ['нд', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'];

    return days[date.getDay()];
  }
}
